export const adminOrganizationsSearch = (params: { q: string }) => `q:${params.q}`;
